import { render, staticRenderFns } from "./CollageItem.vue?vue&type=template&id=19810af8"
import script from "./CollageItem.vue?vue&type=script&lang=js"
export * from "./CollageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports